import { InternalValuationReviewStore } from "../../../stores/internalValuationReviewStore";
import { ComparablesPage } from "../comparablesPage";
import { chunkArray } from "../../../utils";

interface Page2Props {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const Page2 = ({ internalValuationReviewStore }: Page2Props) => {
  const [subjectProperty, ...compForms] = internalValuationReviewStore.propertyCompFormStores.map(store => store.getFlattenedValues());

  const compFormsArrays = chunkArray(compForms);

  return (
    <>
      {compFormsArrays.map((compForms, index) => (
        <ComparablesPage
          key={`comparable-properties-page-${index + 1}`}
          compForms={[subjectProperty, ...compForms]}
          startIndex={index * 3}
          subjectPropertyColumnBg="#B8F7FA"
          reportImages={internalValuationReviewStore.reportImages}
        />
      ))}
    </>
  );
};
